import { Box, Stack } from "@mui/material";
import React from "react";
import { EyeICON } from "../../../assets/icons";
import { CustomButton } from "../../../components";
import SigninTextInput from "../../../components/SigninTextInput";
import i18n from "../../../i18n-config";
import theme from "../../../theme/theme";
import { capitalizeFirstLetter } from "../../../utils/strings";

function Passwords() {
  return (
    <Stack
      justifyContent={"center"}
      alignItems={"center"}
      sx={{
        backgroundColor: "white",
        borderRadius: 2,
        p: 2,
        py: 3,
      }}
    >
      <SigninTextInput
        title={capitalizeFirstLetter(i18n.t("mdp_actuel"))}
        value={undefined}
        type="password"
        endIcon={<EyeICON />}
        onChange={(value: string) => console.log(value)}
        rootStyle={{width: 400}}
      />
      <SigninTextInput
        title={capitalizeFirstLetter(i18n.t("nouveau_mot_pass"))}
        value={undefined}
        type="password"
        endIcon={<EyeICON />}
        onChange={(value: string) => console.log(value)}
        rootStyle={{width: 400}}
      />
      <SigninTextInput
        title={capitalizeFirstLetter(i18n.t("confirmer_mot_pass"))}
        value={undefined}
        type="password"
        onChange={(value: string) => console.log(value)}
        rootStyle={{width: 400}}
      />
      <CustomButton
        title={capitalizeFirstLetter(i18n.t("enregistrer"))}
        rootStyle={{
          width: 400,
          height: 50,
          marginTop: 10,
        }}
        titleStyle={{ color: theme.colors.white }}
      />
    </Stack>
  );
}

export default Passwords;
